import e from "../../../utils/data/tabs.js";
import { SampleTestStatus as s, testTypes as t } from "../../../utils/data/aitests.js";
const l = {
  uistate: {
    visibleTab: e.diagnose,
    showMenu: !1,
    // ? is this supposed to be the default value
    testType: t,
    // ? Btw @dkasiedu, what do these repesent
    /** @type {[boolean, number, any[]]} */
    profileComplete: [!1, 0, []],
    showProfilePopUp: !1,
    sampleTestStatus: s.SKIPPED,
    theme: null,
    hasDiscardedDisclaimer: !1
  },
  datastate: { user: {}, reviews: {}, testDetails: {}, hasTestHistory: !0, hasSeenChatSuggestions: !1 }
};
export {
  l as AppInitialState
};
